import { AccountData, Language, PaymentFormType } from '../api';

// Only order and pass payments go through the tokenizing page. A gift-card purchase never saves a
// card (the backend's voucher branch does not ask for one), and redeeming one takes no payment.
const TOKENIZING_PAYMENT_FORM_TYPES: (PaymentFormType | null | undefined)[] = [
  PaymentFormType.ORDER,
  PaymentFormType.PASS,
];

/**
 * Whether this payment will save the customer's card, and therefore has to ask for consent first.
 *
 * A card is only kept when the account's payment provider saves cards, and only when the page opts in.
 * Recurring passes keep it toothey are billed monthly off the saved card so they ask on the same terms and the backend
 * records the answer. Callers add the "is a card actually being charged" test, which the backend
 * mirrors in OrderLogic.save_order and PassLogic.create_pass.
 *
 * `orderPage` is an OrderPageData or a PassOrderPageData; the widget holds it untyped (`orderPage: any`
 * on OrderPageState), so this takes the loose type rather than forcing casts at every call site.
 */
export const isSaveCardConsentRequired = (
  orderPage: any,
  account: AccountData | undefined,
  paymentFormType: PaymentFormType | null | undefined,
): boolean => {
  if (!TOKENIZING_PAYMENT_FORM_TYPES.includes(paymentFormType)) {
    return false;
  }
  if (!orderPage?.save_card_config?.enabled) {
    return false;
  }
  // A merchant can enable this and later move to a provider that cannot save cards, leaving the config behind.
  return account?.payment_integration_settings?.capabilities?.saved_cards === true;
};

/**
 * The merchant's own consent wording, in the customer's language. Falls back to English rather than
 * rendering an empty checkbox -- the label is optional on the config even though LabelData requires
 * both languages once it exists.
 */
export const getSaveCardConsentLabel = (orderPage?: any, language?: Language): string => {
  const label = orderPage?.save_card_config?.label;
  if (!label) {
    return '';
  }
  return (language && label[language]) || label.en || '';
};
